import React from "react";
import styled from "styled-components";
import DelhiSpecial from "../../../../assets/images/delhi/DelhiSpecial.jpeg";
import HyderabadSpecial from "../../../../assets/images/hyderabad/HyderabadSpecial.jpeg";
import BangaloreSpecial from "../../../../assets/images/bangalore/BangaloreSpecial.jpeg";
import MumbaiSpecial from "../../../../assets/images/mumbai/MumbaiSpecial.jpeg";
import ChennaiSpecial from "../../../../assets/images/chennai/ChennaiSpecial.jpeg";

import { useNavigate } from "react-router";

const LocationContainer = styled.div`
  padding: 2rem 0;
  width: 90%;
  margin: auto;

  .heading {
    font-size: 40px;
    font-weight: 600;
    line-height: 49px;
    padding-bottom: 3rem;
    font-family: "DM Sans", sans-serif;

    @media only screen and (max-width: 1020px) {
      font-size: 24px;
      line-height: 30px;
    }
  }

  .containers {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    justify-content: space-around;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 2rem;

    @media only screen and (max-width: 1200px) {
      grid-template-columns: repeat(1, 1fr);
      width: 100%;
      gap: 1rem;
    }
  }

  @media only screen and (max-width: 767px) {
    padding: 2rem;
    margin: auto;
    width: 100%;
  }
`;

const CityCard = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  padding: 1rem;
  text-align: center;
  transition: transform 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: translateY(-10px);
  }
`;

const CityImage = styled.img`
  width: 150px;
  height: 150px;
  object-fit: cover;
  margin-bottom: 1rem;

  @media only screen and (max-width: 1200px) {
    width: 100px;
    height: 100px;
  }
`;

const CityTitle = styled.h3`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
`;

const LocationShowCase = ({ heading = "Our Locations" }) => {
  const navigate = useNavigate();

  return (
    <LocationContainer>
      <h2 className="heading">{heading}</h2>
      <div className="containers">
        <CityCard onClick={() => navigate("/private-theatres-in-bengaluru")}>
          <CityImage src={BangaloreSpecial} />
          <CityTitle>Bengaluru</CityTitle>
        </CityCard>
        <CityCard onClick={() => navigate("/private-theatres-in-delhi")}>
          <CityImage src={DelhiSpecial} />
          <CityTitle>Delhi NCR</CityTitle>
        </CityCard>
        <CityCard onClick={() => navigate("/private-theatres-in-hyderabad")}>
          <CityImage src={HyderabadSpecial} />
          <CityTitle>Hyderabad</CityTitle>
        </CityCard>
        <CityCard onClick={() => navigate("/private-theatres-in-mumbai")}>
          <CityImage src={MumbaiSpecial} />
          <CityTitle>Mumbai</CityTitle>
        </CityCard>
        <CityCard onClick={() => navigate("/private-theatres-in-chennai")}>
          <CityImage src={ChennaiSpecial} />
          <CityTitle>Chennai</CityTitle>
        </CityCard>
      </div>
    </LocationContainer>
  );
};

export default LocationShowCase;
